"use client"

import {
  GetArticlesQuery,
  GetComponentQuery,
  GetMarketingBannersQuery,
  GetPageByRouteQuery,
} from "@eurodrive/apollo"
import { BlockRenderer } from "@eurodrive/ui"
import { extractProperty, transformProperties } from "@eurodrive/utils"
import { BranchDtoListResponseWrapper, SaleCarDto } from "api"
import { SearchPageMetadata } from "@eurodrive/utils/metadataTypes"
type Props = {
  data: GetPageByRouteQuery
  locale: string
  articles: GetArticlesQuery
  marketing: GetMarketingBannersQuery
  branches: BranchDtoListResponseWrapper
  branchesUmbraco: GetComponentQuery
  brands: GetComponentQuery
  carsStandard: SaleCarDto[]
  carsPremium: SaleCarDto[]
  bestSellerCars: SaleCarDto[]
  metadata: SearchPageMetadata
  contactForm: GetPageByRouteQuery
  typeImages: { carName: string; imageNormal: string; imageOn: string }[]
}

const components = {
  heroSection: () => import("./Hero/Hero"),
  SearchBlock: () => import("./SearchBlock/SearchBlock"),
  brandCarousel: () => import("./BrandCarousel"),
  carCarousel: () => import("./CarCarousel"),
  reasonsWhy: () => import("@eurodrive/ui/ReasonsWhy"),
  leasing: () => import("./Leasing"),
  about: () => import("./About"),
  bestSellers: () => import("./BestSellers"),
  branches: () => import("./Branches"),
  articles: () => import("@eurodrive/ui/Articles"),
  marketing: () => import("@eurodrive/ui/Marketing"),
  selectContactForm: () => import("@eurodrive/ui/FormBlock"),
}

export default function Homepage({
  data,
  locale,
  articles,
  marketing,
  branches,
  branchesUmbraco,
  brands,
  metadata,
  contactForm,
  typeImages,
  carsStandard,
  carsPremium,
  bestSellerCars,
}: Props) {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  let carCarouselCount = 0 // Initialize counter

  return (
    <>
      {blocks?.blocks?.map((block: any, index: number) => {
        let blockProps = {}
        if (block.blockType === "articles") {
          blockProps = { articles }
        }
        if (block.blockType === "marketing") {
          blockProps = { marketing }
        }
        if (block.blockType === "branches") {
          blockProps = { branches, branchesUmbraco }
        }
        if (block.blockType === "brandCarousel") {
          blockProps = { brands }
        }
        if (block.blockType === "carCarousel") {
          const categoryID = extractProperty(block, "categoryID") as string
          // END-86 merged the luxury category into premium, so a carousel still
          // configured as "Luxury" in Umbraco has no row of its own any more.
          // Unrecognised ids render nothing rather than defaulting into premium,
          // which would silently duplicate that row.
          const carsByCategory: Record<string, SaleCarDto[]> = {
            Market: carsStandard,
            Premium: carsPremium,
          }
          const cars = carsByCategory[categoryID]
          if (!cars) return null

          carCarouselCount++
          blockProps = {
            cars,
            brands,
            variant: carCarouselCount === 1 ? "a" : "b",
          }
        }
        if (block.blockType === "bestSellers") {
          blockProps = {
            bestSellerCars,
          }
        }
        if (block.blockType === "SearchBlock") {
          blockProps = { metadata, typeImages }
        }
        if (block.blockType === "selectContactForm") {
          blockProps = { contactForm }
        }
        return (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            components={components}
            locale={locale}
            props={blockProps}
          />
        )
      })}
    </>
  )
}
